import React from 'react';
import CollectionPage from '../shared/CollectionPage';
import useLegoData from '../../hooks/useLegoData';

/**
 * LEGO Collection Dashboard component
 * Uses the generic CollectionPage with LEGO-specific configuration
 */
const LegoDashboard = () => {
  // Use LEGO-specific data hook
  const { getFormattedImageUrl } = useLegoData();

  // LEGO-specific filter options - could be expanded with actual theme data
  const legoFilterOptions = [
    { value: '', label: 'All Themes' },
    { value: '1', label: 'Technic' },
    { value: '22', label: 'Creator' },
    { value: '158', label: 'Star Wars' },
    { value: '246', label: 'Harry Potter' },
    { value: '593', label: 'Ideas' },
    { value: '576', label: 'Ninjago' },
    { value: '621', label: 'Marvel' },
    { value: '695', label: 'DC Comics' }
  ];

  // LEGO-specific render props
  const legoRenderProps = {
    getImageUrl: (item) => item.set_img_url || item.imageUrl,
    getItemName: (item) => item.name,
    getItemSubtitle: (item) => {
      const setNum = item.setNum || item.set_num;
      return `Set #: ${setNum ? setNum.split('-')[0] : 'N/A'} • Year: ${item.year || 'N/A'}`;
    },
    getItemDetails: (item) => `Theme ID: ${item.themeId || item.theme_id || 'N/A'}`,
    // Enable price lookup for LEGO sets
    showMarketValue: () => true
  };

  // LEGO-specific filter function
  const getLegoFilterValue = (item) => item.themeId?.toString() || item.theme_id?.toString();

  // LEGO-specific edit fields
  const legoEditFields = [
    {
      name: 'name',
      label: 'Name',
      type: 'text',
      required: true,
      gridProps: { xs: 12 }
    },
    {
      name: 'setNum',
      label: 'Set Number',
      type: 'text',
      required: true,
      gridProps: { xs: 12, sm: 6 }
    },
    {
      name: 'year',
      label: 'Year',
      type: 'number',
      required: false,
      gridProps: { xs: 12, sm: 6 }
    },
    {
      name: 'themeId',
      label: 'Theme ID',
      type: 'text',
      required: false,
      gridProps: { xs: 12, sm: 6 }
    },
    {
      name: 'condition',
      label: 'Condition',
      type: 'select',
      options: ['New', 'Used', 'Complete', 'Incomplete', 'Sealed', 'Opened'],
      required: false,
      gridProps: { xs: 12, sm: 6 }
    },
    {
      name: 'priority',
      label: 'Priority',
      type: 'select',
      options: ['Low', 'Medium', 'High'],
      required: false,
      gridProps: { xs: 12, sm: 6 }
    },
    {
      name: 'set_img_url',
      label: 'Image URL',
      type: 'text',
      required: false,
      gridProps: { xs: 12 }
    },
    {
      name: 'rating',
      label: 'Rating',
      type: 'rating',
      required: false,
      gridProps: { xs: 12 }
    },
    {
      name: 'notes',
      label: 'Notes',
      type: 'text',
      multiline: true,
      rows: 4,
      required: false,
      gridProps: { xs: 12 }
    }
  ];

  return (
    <CollectionPage
      collectionType="lego"
      title="LEGO Collection"
      renderProps={legoRenderProps}
      filterOptions={legoFilterOptions}
      getFilterValue={getLegoFilterValue}
      editFields={legoEditFields}
      itemType="lego"
    />
  );
};

export default LegoDashboard;
